import React from 'react';
import { useState } from 'react';
import { usePageSwipe } from './Hooks/UsePageSwipe';
import { usePageEnter } from './Hooks/UsePageEnter';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import { Highlight2 } from './App';

import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
  Window,
    Avatar,
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';


const BackPage = () =>{
    usePageEnter();
    console.log(Highlight2)
    const { transitionTo } = usePageSwipe(null, Highlight2);  // swipe up → AboutPage

    const [open, setOpen] = useState(false);

    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    
    return(
               <ThemeProvider theme={rose}>
                   <div style={{height: "100%", display: "flex", flexDirection:"row", width: '100%', justifyContent: "space-around"}}>
                        
                        <div style={{ display: "flex", flexDirection:"column", width: '10%', justifyContent: "space-around"}}>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ComingSoon')}>Blog</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/Essays/intro')}>Essays</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/Resume')}>My Resume and Credits</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/Xarasguide')}>Xara's gay ass guide to Los Angeles</Button>
                       </div>
                        
                       <div style={{display: "flex", flexDirection:"column", width: '10%', justifyContent: "space-around"}}>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ComicsPage')}>Art & Comics</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/EnvironmentPage')}>Environments and Levels</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ComingSoon')}>Stories and Scripts</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/Roblox')}>Roblox Works</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ObjectsPage')}>3D Art</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/CodePage')}>Code Snippets</Button>
                            <Button style={{ height: 'auto', padding: '10px' }} fullWidth onClick={() => handleRedirect('/ComingSoon')}>Concept Art</Button>
                       </div>
               
                   </div>
               </ThemeProvider>
           );
}

export default BackPage;
